// Export the tour steps for PersonalInfo form fields
export const personalInfoGuideSteps = [
  {
    element: "#SPF-firstName",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">First Name</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Enter your first name as it appears on official documents.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">This will be displayed to brands and other affiliates.</p>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#SPF-lastName",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Last Name</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Enter your last name to complete your full name.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">Your full name helps brands identify you professionally.</p>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#SPF-email",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Email Address</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Your email is used for account verification and communications.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">Click "Change" to update your email address if needed.</p>
          </div>
        </div>`,
      side: "left" as const,
      align: "start" as const,
    },
  },
  {
    element: "#SPF-phone",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Phone Number</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Add your phone number for account security and support.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">Select your country code and enter your number.</p>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#SPF-gender",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Gender</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Select your gender for demographic information.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">This helps brands understand their affiliate demographics.</p>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#SPF-age",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Age</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Enter your age (must be 18 or older).</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">Age information helps with brand matching and compliance.</p>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#SPF-country",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Country</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Select your country of residence.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">This helps with payment processing and tax compliance.</p>
          </div>
        </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#SPF-address",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
                <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
                  <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  </svg>
                </div>
                <span class="text-base font-semibold text-foreground">Address</span>
              </div>`,
      description: `<div class="space-y-3">
                      <p class="text-[12px] text-muted-foreground">Enter your full address, including street, city, state/province, and ZIP/postal code.</p>
                      <div class="bg-brand-100 p-3 rounded-lg">
                        <p class="text-xs text-brand-800 font-medium">Providing your correct address is essential to ensure you receive your affiliate milestone rewards.</p>
                      </div>
                    </div>`,
      side: "right" as const,
      align: "start" as const,
    },
  },
  {
    element: "#SPF-password",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Password</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Your password is securely stored and cannot be viewed.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">Click "Change" to update your password.</p>
          </div>
        </div>`,
      side: "left" as const,
      align: "start" as const,
    },
  },
  {
    element: "#SPF-save-button",
    popover: {
      title: `<div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-brand-200 rounded-full flex items-center justify-center">
              <svg class="w-4 h-4 text-brand-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span class="text-base font-semibold text-foreground">Save Changes</span>
          </div>`,
      description: `<div class="space-y-3">
          <p class="text-[12px] text-muted-foreground">Save your personal information to update your profile.</p>
          <div class="bg-brand-100 p-3 rounded-lg">
            <p class="text-xs text-brand-800 font-medium">Your updated information will be saved to your account!</p>
          </div>
        </div>`,
      side: "top" as const,
      align: "center" as const,
    },
  },
];


